import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import LoadingSkeleton from '@/shared/components/ui/LoadingSkeleton';
import { useAuth } from '@/shared/hooks/useAuth';
import { buildLoginPath } from '@/shared/routes/paths';

// Renders <Outlet /> rather than taking `children`: the signature change turns
// any leftover inline <ProtectedRoute>…</ProtectedRoute> call site into a
// compile error, which is the only automated check this migration gets.
const ProtectedRoute: React.FC = () => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingSkeleton />;
  if (!user) {
    // Capture the current location to redirect back after auth
    const redirectUrl = location.pathname + location.search;
    return <Navigate to={buildLoginPath(redirectUrl)} replace={true} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
